import React, { useEffect } from 'react';
import { InputNumber, Form, DatePicker } from 'antd';


import locale from 'antd/es/date-picker/locale/ru_RU';

export default function NovieDatiVozvratov(props) {
    const { object, form } = props;
    useEffect(() => {
        form.resetFields();
    }, []);

    return (
        <>
            <Form
                form={form}
                onFinish={props.submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={{
                    ...object
                }}
            >
                <Form.Item
                    label={"Дата"}
                    name={"dataVremya"}
                    rules={[{ required: true, message: 'Пожалуйста, укажите дату!' }]}
                >
                    <DatePicker style={{ width: "100%" }} suffixIcon={<></>} showTime={{ format: 'HH:mm' }} format="YYYY-MM-DD HH:mm" locale={locale} />
                </Form.Item>
                <Form.Item
                    label={"Процент к возврату"}
                    name={"protsent"}
                    rules={[{ required: true, message: 'Пожалуйста, укажите процент к возврату!' }]}
                >
                    <InputNumber min={1} />
                </Form.Item>
            </Form>
        </>
    );
}
